import * as React from 'react';
import { MassInquiryPageData, StoreState } from '../../types';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import * as querystring from 'query-string';
import { RouteComponentProps } from 'react-router-dom';
import { LoadMassInquiryVenues, loadMassInquiryVenues } from '../../actions/mass-inquiry';
import MassInquiryPage from './MassInquiryPage';
import { submit, FormAction } from 'redux-form';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';

interface ActionProps {
    load: (venue_ids: number[]) => Promise<MassInquiryPageData>;
    submitForm: () => void;
}

interface StateProps {
    data: MassInquiryPageData;
}

type Props = ActionProps & StateProps & RouteComponentProps;

class MassInquiryPageContainer extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);

        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onBrowseMore = this.onBrowseMore.bind(this);
    }

    componentDidMount() {
        const qps = querystring.parse(this.props.location.search);
        const venue_ids = qps.venue_id;
        let venue_ids_array = [];
        if (!isNaN(Number(venue_ids))) {
            venue_ids_array = [Number(venue_ids)];
        } else {
            venue_ids_array = venue_ids as [];
        }
        this.props.load(venue_ids_array).then((data) => {
            if (this.hasSendQp()) {
                this.props.submitForm();
            }
        });

        // if window is opened w\o send param (when unchecking a venue)
        if (!this.hasSendQp()) {
            logEvent(AnalyticsEvent.EVTNM_VISITED_POST_OUTREACH, {
                Source: this.getSourceQp(),
            });
        }
    }

    onFormSubmit(positions: number[]) {
        logEvent(AnalyticsEvent.EVTNM_CLICKED_POST_OUTREACH_INQUIRE, {
            Source: this.getSourceQp(),
            Position: positions,
            'Number of venues': positions.length,
        });
    }

    onBrowseMore() {
        logEvent(AnalyticsEvent.EVTNM_CLICKED_POST_OUTREACH_SUCCESS_BROWSE_MORE, {
            Source: this.getSourceQp(),
        });
    }

    getUnselectedQp() {
        const qps = querystring.parse(this.props.location.search) as unknown as Record<string, number>;
        return qps.unselected;
    }

    getUserTokenQp() {
        const qps = querystring.parse(this.props.location.search) as Record<string, string>;
        return qps.token;
    }

    hasSendQp() {
        const qps = querystring.parse(this.props.location.search) as Record<string, string | number>;
        return qps.send && qps.send == 1;
    }

    getSourceQp() {
        const qps = querystring.parse(this.props.location.search);
        return qps.src;
    }

    render() {
        return (
            <MassInquiryPage
                venueData={this.props.data}
                unselectedPos={this.getUnselectedQp()}
                userToken={this.getUserTokenQp()}
                onFormSubmit={this.onFormSubmit}
                onBrowseMore={this.onBrowseMore}
            />
        );
    }
}

const mapStateToProps = (state: StoreState, ownProps: {}): StateProps => ({
    data: state.massInquiryVenuesData,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<StoreState, undefined, LoadMassInquiryVenues | FormAction>): ActionProps => ({
    load: (venueIds: number[]) => dispatch(loadMassInquiryVenues(venueIds)),
    submitForm: () => dispatch(submit('OutreachPushForm')),
});

export default connect(mapStateToProps, mapDispatchToProps)(MassInquiryPageContainer);
